@if (isVisible()) {
<div class="theme-modal-backdrop">
  <div class="theme-modal" (click)="$event.stopPropagation()">
    <div class="theme-modal-header">
      <h3>
        {{ isEditMode() ? "Edit Theme" : "Create Theme" }}
      </h3>
      <button class="btn btn-light" (click)="onClose()" [disabled]="isLoading()">
        ✕
      </button>
    </div>

    <form [formGroup]="themeForm" (ngSubmit)="onSubmit()">
      <div class="theme-modal-body">

        <div class="form-grid">

          <!-- Name -->
          <div class="form-row">
            <label>Name<span class="text-danger">*</span></label>
            <input class="input" type="text" formControlName="name" placeholder="Enter theme name" />
            @if (isFormGroupInvalid("name")) {
            <span class="text-danger">Please enter valid name</span>
            }
          </div>

          <!-- Entry Fee -->
          <div class="form-row">
            <label>Entry Fee</label>
            <input class="input" type="number" min="0" [readOnly]="isEditMode()" formControlName="entryFee"
              placeholder="Enter entry fee" />
            @if (isFormGroupInvalid("entryFee")) {
            <span class="text-danger">Entry fee must be 0 or greater</span>
            }
          </div>

          <!-- Participants Count -->
          <div class="form-row">
            <label>Participants Count</label>
            <input class="input" type="number" min="2" [readOnly]="isEditMode()" formControlName="participantsCount"
              placeholder="Enter number of participants" />
            @if (isFormGroupInvalid("participantsCount")) {
            <span class="text-danger">At least 2 participants required</span>
            }
          </div>

          <!-- Interests Count -->
          <div class="form-row">
            <label>Interests Count</label>
            <input class="input" type="number" min="0" [readOnly]="isEditMode()" formControlName="interestsCount"
              placeholder="Enter number of interests" />
            @if (isFormGroupInvalid("interestsCount")) {
            <span class="text-danger">At least 1 interest is required</span>
            }
          </div>

          <!-- Participants Gender -->
          <div class="form-row">
            <label>Participants Gender</label>
            <select class="select" [disabled]="isEditMode()" formControlName="participantsGender">
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

          <!-- Lobby Start Time -->
          <div class="form-row">
            <label>Lobby Start Time</label>
            <input class="input" type="datetime-local" formControlName="startDate"
              placeholder="Select start date and time" />
          </div>

          <!-- Generic Question Group -->
          <div class="form-row">
            <label>Generic Question Group</label>
            <select class="select" formControlName="questionGroup">
              <option value="">Select a group</option>
              @for (group of questionGroups(); track group._id || group.name) {
              <option [value]="group._id || group.name">{{ group.name || group }}</option>
              }
            </select>
          </div>

          <!-- Rounds per interest -->
          <div class="form-row">
            <label>Rounds per interest</label>
            <input class="input" type="number" min="1" formControlName="roundsPerInterest"
              placeholder="Enter rounds per interest" />
            @if (isFormGroupInvalid("roundsPerInterest")) {
            <span class="text-danger">Must be at least 1 round</span>
            }
          </div>

          <!-- Generic Questions Duration -->
          <div class="form-row">
            <label>Question Duration (Seconds)</label>
            <input class="input" type="number" min="5" max="300" formControlName="genericQuestionsDuration"
              placeholder="Enter duration" />
            @if (isFormGroupInvalid("genericQuestionsDuration")) {
            <span class="text-danger">Must be between 5 and 300 seconds</span>
            }
          </div>

          <!-- Status -->
          <div class="form-row">
            <label>Status</label>
            <select class="select" formControlName="isActive">
              <option [value]="true">Active</option>
              <option [value]="false">Inactive</option>
            </select>
          </div>

          <!-- Description — full width -->
          <div class="form-row full-width">
            <label>Description (Min 25)</label>
            <textarea class="input" rows="2" formControlName="description"
              placeholder="Optional description"></textarea>
            @if (isFormGroupInvalid("description")) {
            <span class="text-danger">Description must be at least 25 characters</span>
            }
          </div>




          <!-- Image — full width -->
          <div class="form-row full-width">
            <label>Image</label>

            <input #fileInput type="file" accept="image/*" class="d-none" (change)="onFileChange($event)" />

            @if (!showCropper && !croppedPreviewUrl) {
            @if (isEditMode() && theme()?.image?.signedUrl) {
            <button type="button" class="btn btn-black mb-2" (click)="undoClearedImage()">
              <i class="fa-solid fa-rotate-left"></i> Undo
            </button>
            }
            <div class="upload-area" (click)="triggerFileInput()">
              <i class="fa-solid fa-cloud-arrow-up" style="font-size: 1.5rem;"></i>
              <p class="mb-1 mt-2 fw-semibold">Click to upload image</p>
              <small class="text-muted">PNG, JPG, WEBP supported</small>
            </div>
            }

            @if (showCropper && cropImgSrc) {
            <div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <label class="mb-0">Crop Image</label>
                <small class="text-muted">Drag to move · Drag corners to resize</small>
              </div>
              <div class="cropper-wrapper">
                <canvas #cropCanvas width="480" height="280" class="crop-canvas" (mousedown)="onCanvasMouseDown($event)"
                  (mousemove)="onCanvasMouseMove($event)" (mouseup)="onCanvasMouseUp()"
                  (mouseleave)="onCanvasMouseUp()">
                </canvas>
              </div>
              <div class="text-end mt-2">
                <button type="button" class="btn btn-light border me-2 btn-sm" (click)="removeImage()">
                  Cancel
                </button>
                <button type="button" class="btn btn-primary btn-sm" (click)="applyCrop()">
                  <i class="fa-solid fa-check me-1"></i> Apply Crop
                </button>
              </div>
            </div>
            }

            @if (!showCropper && croppedPreviewUrl) {
            <div class="d-flex align-items-center gap-3">
              <div style="position: relative; display: inline-block;">
                <img [src]="croppedPreviewUrl" alt="Preview" class="avatar" style="border-radius: 6px; cursor: pointer;"
                  (click)="openImageInNewTab(croppedPreviewUrl)" />
                <button type="button" class="btn-close"
                  style="position:absolute;top:-6px;right:-6px;background-color:#fff;border-radius:50%;box-shadow:0 1px 4px rgba(0,0,0,0.2);padding:4px;"
                  (click)="removeImage()">
                </button>
              </div>
              <div class="d-flex flex-column gap-2">
                @if (croppedBlob) {
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="reCrop()">
                  <i class="fa-solid fa-crop me-1"></i> Re-crop
                </button>
                }

              </div>
            </div>
            }

            @if (showImgError()) {
            <span class="text-danger">Image is required</span>
            }
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-primary custom-gradient-btn" [disabled]="isLoading()">
          @if (isLoading()) {
          <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          {{ isEditMode() ? "Update" : "Create" }}
          } @else {
          {{ isEditMode() ? "Update" : "Create" }}
          }
        </button>
      </div>
    </form>
  </div>
</div>
}